import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { PageName } from './types';

export interface FBPagesState {
  mainClients: {
    elemsPerPage: number;
  };
  mainAccounts: {
    elemsPerPage: number;
  };
  mainCabs: {
    elemsPerPage: number;
  };
  mainCampigns: {
    elemsPerPage: number;
  };
  mainAdsets: {
    elemsPerPage: number;
  };
  mainAds: {
    elemsPerPage: number;
  };
  comments: {
    elemsPerPage: number;
  };
  proxy: {
    elemsPerPage: number;
  };
}

const initialState: FBPagesState = {
  mainClients: {
    elemsPerPage: 20,
  },
  mainAccounts: {
    elemsPerPage: 20,
  },
  mainCabs: {
    elemsPerPage: 20,
  },
  mainCampigns: {
    elemsPerPage: 20,
  },
  mainAdsets: {
    elemsPerPage: 20,
  },
  mainAds: {
    elemsPerPage: 20,
  },
  comments: {
    elemsPerPage: 20,
  },
  proxy: {
    elemsPerPage: 20,
  },
};

export const fbPagesSlice = createSlice({
  name: 'fbpages',
  initialState,
  reducers: {
    setElemsPerPage: (state, action: PayloadAction<{ page: PageName; elemsPerPage: number }>) => {
      const { page, elemsPerPage } = action.payload;
      state[page] = { ...state[page], elemsPerPage: elemsPerPage };
    },
  },
});

export const fbPagesReducer = fbPagesSlice.reducer;

export const { setElemsPerPage } = fbPagesSlice.actions;
